import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-youtube-video-insights-checklist',
  templateUrl: './help-youtube-video-insights-checklist.component.html'
})
export class HelpYoutubeVideoInsightsChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
